var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "actions-wrapper" }, [
    _c(
      "div",
      [
        _c(
          "v-menu",
          {
            attrs: { "offset-y": "" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          { attrs: { color: "primary", dark: "" } },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("\n          Actions\n        ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "v-list",
              _vm._l(_vm.actions, function (action, idx) {
                return _c("actions-link-list-item", {
                  key: idx,
                  attrs: { action: action, params: _vm.params },
                })
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }